<template>
  <div v-if="isShow" class="fix-middle" :style="{ 'z-index': zIndex }" @click="modifyZIndex">
    <el-tabs v-model="editableTabsValue" type="card" :closable="true" @tab-remove="removeTab">
      <el-tab-pane v-for="item in editableTabs" :key="item.id" :name="item.id">
        <span slot="label">
          <span
            v-if="editableTabsValue == item.id && item.radish.status"
            class="simi-icon"
            style="top:12px;left:5px"
            size="mini"
            @click="getSimi(item.radish)"
          >
            <i :class="simiClass(item.radish.status)"></i>
          </span>
          <span>{{ item.title }}</span>
        </span>
        <radishDetail :id="item.id" :ref="item.id" type="small" :on-close="closeTab"></radishDetail>
      </el-tab-pane>
    </el-tabs>

    <div class="fix-middle-actions">
      <el-button circle size="mini" icon="el-icon-close" title="关闭全部" @click="closeAllTab"></el-button>
      <el-button circle size="mini" icon="el-icon-arrow-up" title="收起" @click="collapse"></el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      editableTabsValue: '',
      editableTabs: [],
      zIndex: 1003,
      unsave: {},
    }
  },
  methods: {
    modifyZIndex() {
      this.zIndex = app.root.dragindex++
    },
    addTab: async function(param) {
      const { id, title } = param
      const unsaveId = Object.keys(this.unsave)
      if (unsaveId.length > 0 && unsaveId.includes(id)) {
        this.editableTabsValue = id
        // return false
      }
      const tabs = this.editableTabs
      const ids = tabs.map(tab => tab.id)
      if (ids.includes(id)) {
        this.removeTab(id)
      }
      const info = {
        title: title,
        id: id,
        radish: {},
      }
      const radish = await app.service('radish').simpleFetch({ _id: id, fields: { 姓名: 1, status: 1, thirdId: 1 } })
      if (radish.status === 'success') {
        if (radish.msg === 'have') {
          info.radish = radish.data
          if (!title) {
            info.title = radish.data['姓名']
          }
        } else {
          return this.$message.info('人选不存在')
        }
      } else {
        return this.$message.error(radish.msg)
      }
      if (tabs.length > 3) {
        const first = ids[0]
        if (unsaveId.length > 0 && unsaveId.includes(first)) {
          this.$confirm(`${this.unsave[first]}还有沟通日志未保存，确定【关闭】吗?`, '提示', {
            confirmButtonText: '确定关闭',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              delete this.unsave[first]
              this.editableTabs = tabs.filter(tab => tab.id !== first)
              this.editableTabs.push(info)
              this.modifyZIndex()
              this.editableTabsValue = id
              this.isShow = true
            })
            .catch(() => {
              this.editableTabsValue = first
            })
        } else {
          this.editableTabs.shift()
          this.editableTabs.push(info)
          this.modifyZIndex()
          this.editableTabsValue = id
          this.isShow = true
        }
      } else {
        this.editableTabs.push(info)
        this.modifyZIndex()
        this.editableTabsValue = id
        this.isShow = true
      }
    },
    removeTab: function(targetName) {
      const tabs = this.editableTabs
      let activeName = this.editableTabsValue
      const unsaveId = Object.keys(this.unsave)
      if (unsaveId.length > 0 && unsaveId.includes(targetName)) {
        this.$confirm(`${this.unsave[targetName]}还有沟通日志未保存，确定【关闭】吗?`, '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (activeName === targetName) {
              tabs.forEach((tab, index) => {
                if (tab.id === targetName) {
                  const nextTab = tabs[index + 1] || tabs[index - 1]
                  if (nextTab) {
                    activeName = nextTab.id
                  }
                }
              })
            }
            delete this.unsave[targetName]
            this.editableTabsValue = activeName
            this.editableTabs = tabs.filter(tab => tab.id !== targetName)
            this.reloadWindow()
          })
          .catch(() => {})
      } else {
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.id === targetName) {
              const nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.id
              }
            }
          })
        }
        this.editableTabsValue = activeName
        this.editableTabs = tabs.filter(tab => tab.id !== targetName)
        this.reloadWindow()
      }
    },
    closeTab: function() {
      this.removeTab(this.editableTabsValue)
    },
    closeAllTab: function() {
      const unsaveName = Object.values(this.unsave)
      if (unsaveName.length > 0) {
        this.$confirm(`${JSON.stringify(unsaveName)}还有沟通日志未保存，确定【关闭】吗?`, '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.editableTabs = []
            this.editableTabsValue = ''
            this.unsave = {}
            this.isShow = false
            this.reloadWindow()
          })
          .catch(() => {})
      } else {
        this.editableTabs = []
        this.editableTabsValue = ''
        this.isShow = false
        this.reloadWindow()
      }
    },
    collapse: function() {
      this.editableTabsValue = ''
    },
    reloadWindow() {
      if (this.$route.name == 'radish-detail-blank') {
        window.location.reload()
      }
    },
    simiClass: function(status) {
      if (status == 1) {
        return 'el-icon-question icon-lightred'
      } else if (status == 2) {
        return 'el-icon-success icon-blue'
      } else if (status == 3) {
        return 'el-icon-warning icon-red'
      } else if (status == 4) {
        return 'el-icon-error icon-grey'
      } else {
        return ''
      }
    },
    getSimi: async function(item) {
      if (item.status && item.status > 0) {
        app.root.$refs.simiDialog.show(item)
      }
    },
  },
}
</script>
<style>
.fix-middle {
  width: 40vw;
  position: fixed;
  top: 0;
  right: 20vw;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
}
.fix-middle-actions {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
  line-height: 40px;
  padding-right: 5px;
}
.fix-middle > .el-tabs > .el-tabs__header {
  margin: 0;
  background-color: #f6f6f6;
}
.fix-middle .el-tabs__content {
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
}
.fix-middle .el-button + .el-button {
  margin-left: 0;
}
.fix-middle .el-tabs__item {
  height: auto;
}
.radish-detail-main {
  height: 100vh;
  position: relative;
}
.radish-detail-wapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
.radish-detail-actions {
  position: absolute;
  width: 100%;
  padding: 5px 15px 5px 5px;
  border-bottom: 1px solid #e4e7ed;
}
.radish-detail-body {
  position: absolute;
  width: 100%;
  top: 45px;
  bottom: 0;
  padding: 0 5px 100px 5px;
  background-color: #fff;
  overflow-y: auto;
}
</style>
